export function fromDraftLegalTermsOld(legalTerms) {
  if (!legalTerms) {
    return {
      id: '',
      contentType: 'richText',
      name: '',
      richTextContent: []
    };
  }
  return legalTerms.type === 'pdf' ? {
    id: legalTerms.libraryLegalTermsId,
    contentType: 'pdf',
    name: legalTerms.displayName || '',
    pdfUniqueName: legalTerms.pdfUniqueName || ''
  } : {
    id: 'libraryLegalTermsId' in legalTerms ? legalTerms.libraryLegalTermsId : '',
    contentType: 'richText',
    name: legalTerms.type === 'richText' ? legalTerms.displayName : '',
    richTextContent: legalTerms.type === 'richText' ? legalTerms.richTextContent : []
  };
}
export function fromDraftLegalTerms() {
  let legalTermsArray = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return legalTermsArray.map(legalTerms => {
    switch (legalTerms.type) {
      case 'pdf':
        return {
          id: legalTerms.legalTermsId,
          contentType: 'pdf',
          name: legalTerms.displayName,
          pdfUniqueName: legalTerms.pdf.pdfName
        };
      case 'richText':
        return {
          id: legalTerms.legalTermsId,
          contentType: 'richText',
          name: legalTerms.displayName,
          richTextContent: []
        };
    }
  });
}
function duplicateLegalTerms(legalTerms) {
  if (legalTerms.contentType === 'pdf') {
    return {
      type: 'pdf',
      displayName: legalTerms.name,
      pdfUniqueName: legalTerms.pdfUniqueName,
      libraryLegalTermsId: legalTerms.id
    };
  } else {
    return {
      type: 'richText',
      displayName: legalTerms.name,
      richTextContent: legalTerms.richTextContent
    };
  }
}

/* @deprecated delete once feature flag MULTIPLE_LEGAL_TERMS_DOCUMENTS is merged */
export function toDraftLegalTermsOld(legalTerms, legalTermsNotFoundInLibrary) {
  return legalTermsNotFoundInLibrary ? duplicateLegalTerms(legalTerms) : {
    libraryLegalTermsId: legalTerms.id,
    type: 'libraryLegalTermsId'
  };
}
export function toDraftLegalTermsDocuments(legalTerms) {
  switch (legalTerms.contentType) {
    case 'pdf':
      return [{
        type: 'pdf',
        displayName: legalTerms.name,
        legalTermsId: legalTerms.id,
        termsOfService: {
          type: 'none'
        },
        pdf: {
          pdfName: legalTerms.pdfUniqueName
        }
      }];
    case 'richText':
      return [{
        type: 'richText',
        legalTermsId: legalTerms.id,
        displayName: legalTerms.name,
        termsOfService: {
          type: 'none'
        },
        richText: {
          textId: legalTerms.id
        }
      }];
  }
}